import React from "react";
import { Box, Button } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { ImgContext } from "../Context/ImageCon";
import axios from "../axios";
function Image() {
  const [image, setImage] = React.useState("");
  // eslint-disable-next-line no-unused-vars
  const [img, setImg] = React.useContext(ImgContext);

  let handleClick = (e) => {
    console.log(e.target.files[0]);
    setImage(e.target.files[0]);
  };

  let handleQR = () => {
    axios
      .post(
        "image/",
        {
          name: image.name,
          uploads: image,
        },
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      )
      .then((res) => {
        console.log(res.data);
        setImg(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  return (
    <div className="section">
      {localStorage.getItem("access_token") ? (
        <div>
          <input
            accept="image/*"
            className="input-file"
            style={{ display: "none" }}
            id="raised-button-file"
            multiple
            type="file"
            onChange={handleClick}
          />
          <label htmlFor="raised-button-file">
            <Box className="UploadBox">
              <CloudUploadIcon />
            </Box>
          </label>
        </div>
      ) : (
        "  Must be logged in to upload an image"
      )}
      {image ? image.name : null}

      {image ? (
        <Button
          onClick={handleQR}
          style={{ marginTop: "12%", marginLeft: "12%" }}
          variant="contained"
          color="primary"
        >
          Make QR
        </Button>
      ) : null}
    </div>
  );
}

export default Image;
